module.exports = {
	"defaultEnv": "staging",
	"envs": {
		"local": {
			"appPath": "/",
			"resourcePath": "/",
			"graphqlUri": "http://localhost:9250/graphql/v1",
			"gatewayUri": "/",
			"logoutUri": "/",
			"tokenRefreshUri": "http://localhost:9100/v1/token/",
			"keepaliveUri": "/diweb/keepalive"
		},
		"staging": {
			"appPath": "/",
			"resourcePath": "/",
			"graphqlUri": "https://rest.precrowdwisdom.net/graphql/v1",
			"gatewayUri": "/",
			"logoutUri": "/",
			"tokenRefreshUri": "https://auth.precrowdwisdom.net/v1/token/",
			"uploadUri": "https://upload.precrowdwisdom.com/upload/file",
			"keepaliveUri": "/diweb/keepalive"
		},
		"preprod": {
			"appPath": "/",
			"resourcePath": "/",
			"graphqlUri": "https://rest.mycrowdwisdom.net/graphql/v1",
			"gatewayUri": "/",
			"logoutUri": "/",
			"tokenRefreshUri": "https://auth.mycrowdwisdom.net/v1/token/",
			"uploadUri": "https://uploader.mycrowdwisdom.net/upload/file",
			"keepaliveUri": "/diweb/keepalive"
		},
		"uat": {
			"appPath": "/",
			"resourcePath": "/",
			"graphqlUri": "https://rest.uatcrowdwisdom.com/graphql/v1",
			"gatewayUri": "/",
			"logoutUri": "/",
			"tokenRefreshUri": "https://auth.uatcrowdwisdom.com/v1/token/",
			"uploadUri": "https://uploader.uatcrowdwisdom.com/upload/file",
			"keepaliveUri": "/diweb/keepalive"
		},
		"prod2": {
			"appPath": "/",
			"resourcePath": "https://resource.mycrowdwisdom.com/ui/prod/v2/",
			"graphqlUri": "https://env2.mycrowdwisdom.com/api/graphql/v1",
			"gatewayUri": "/",
			"logoutUri": "/",
			"tokenRefreshUri": "https://env2.mycrowdwisdom.com/api/auth/v1/token/",
			"uploadUri": "https://uploader.mycrowdwisdom.com/upload/file",
			"keepaliveUri": "/diweb/keepalive"
		}
	},
	"sentryUri": "https://f4db9ed9fd4341e8b9d6b73cfb10f7fc@o387825.ingest.sentry.io/5223707",
	"editingEnabled": true,
	"service.resolver": "apollo",
	"startup": [
		"CONFIG_LOAD_SUCCESS",
		"LAYOUT_LOAD_SUCCESS",
		"USER_ALL_CONDITIONS_SET"
	]
};


//////////////////
// WEBPACK FOOTER
// ./app.config.dev.json
// module id = 1455
// module chunks = 0